module.exports = "\r\n.report-holder{\r\n    padding:30px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.css
// module id = ./src/app/reports/reports.component.css
// module chunks = main